const product = {
  name: "T-Sirt Male",
  size: "L",
  price: "12",
  parts: [
    {
      name: "front",
      image: "/test_data/img/products/mtshirt/DTGEmbedded.svg"
      //image: "/test_data/img/products/mtshirt/front.png",
      // image:
      //   "http://myalloverprint.com/wp-content/uploads/2020/04/96_PreviewFront.jpg",
    },
    {
      name: "back",
      image: "/test_data/img/products/mtshirt/back.png",
      // image:
      //   "http://myalloverprint.com/wp-content/uploads/2020/04/96_PreviewFront.jpg",
    },
  ],
}

export default JSON.stringify(product)
